import _ from 'lodash'

import i18n from '@/i18n/i18n'
import TarfinProCollateralTypeService from '@/services/admin/TarfinProCollateralTypeService'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const state = {
  types: null,
  type: {}
}

export const mutations = {
  SET_TYPES(state, types) {
    state.types = types.data
  },
  SET_TYPE(state, type) {
    state.type = type
  },
  ADD_TYPE(state, type) {
    state.types.push(type)
  },
  DELETE_TYPE(state, typeId) {
    state.types = _.filter(state.types, function (type) {
      return type.id !== typeId
    })
  }
}

export const getters = {
  getTypeById: state => id => {
    return state.types ? state.types.find(type => type.id === id) : false
  }
}

export const actions = {
  getTypes({ commit, dispatch, state }) {
    if (state.types) return state.types

    return new Promise((resolve, reject) => {
      TarfinProCollateralTypeService.getTypes()
        .then(response => {
          commit('SET_TYPES', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.tarfin_pro_collateral_type.collateral_types')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getType({ commit, dispatch, state, getters }, id) {
    if (id === state.type.id) return state.type

    let type = getters.getTypeById(id)

    if (type) {
      commit('SET_TYPE', type)
      return type
    } else {
      return new Promise((resolve, reject) => {
        TarfinProCollateralTypeService.getType(id)
          .then(response => {
            commit('SET_TYPE', response.data)
            resolve(response.data)
          })
          .catch(err => {
            const notification = {
              type: 'danger',
              message:
                t('store.shared.fetching_problem', {
                  element: t('store.admin.tarfin_pro_collateral_type.collateral_type')
                }) + errorMessage(err)
            }
            dispatch('notification/add', notification, {
              root: true
            })
            reject(err)
          })
      })
    }
  }
}
